/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatchOrderStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
  status: 'NOT_CONFIRMED' | 'PENDING' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'PROCESSED' | 'CANCELED' | 'CONFIRMED' | 'CHECKED_IN' | 'CHECKED_OUT' | 'ORDER_COLLECTED';
}

export function patchOrderStatus(http: HttpClient, rootUrl: string, params: PatchOrderStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchOrderStatus.PATH, 'patch');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchOrderStatus.PATH = '/v1/api/orders/status/{ref}';
